import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { managerMutationToasts } from '@/utils/managerMutationToasts';

const TOAST_ID = 'sign-up-manager';

export const signUpManager: managerTypes.SignUpManager = (data) => {
  return axios.post(`/managers/sign-up`, data);
};

type UseSignUpManagerOptions = {
  config?: MutationConfig<typeof signUpManager>;
};

export function useSignUpManager({ config = {} }: UseSignUpManagerOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      managerMutationToasts.loading(TOAST_ID, 'Creating manager...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['managers']);
      managerMutationToasts.success(TOAST_ID, 'Manager created successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      managerMutationToasts.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: signUpManager,
  });
}
